module.exports = __webpack_public_path__ + "static/media/pay_closed.9b64c2c4.svg";